import React, { useCallback, useEffect, useState } from 'react';
import MasterLayout from '../../masterLayout/MasterLayout';
import Breadcrumb from '../../components/Breadcrumb';
import { notify } from '../../components/common/AppToast';
import KkpPlanningEmptyState from '../../components/kkp/KkpPlanningEmptyState';
import kkpDistribService from '../../services/kkpDistribService';
import { AppInput } from '../../components/ui';
import '../../styles/kkp-planning-page.scss';
import '../../styles/kkp-distrib-page.scss';

const formatFr = (iso) => {
  if (!iso) return '—';
  const [y, m, d] = String(iso).split('-');
  return `${d}/${m}/${y}`;
};

const KkpDistribLivraisonsPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [savingKey, setSavingKey] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      setItems(await kkpDistribService.listLivraisons(12));
    } catch (err) {
      notify.error(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const save = async (item, field, value) => {
    const next = value || null;
    const key = `${item.annee}-${item.mois}-${field}`;
    setSavingKey(key);
    try {
      const saved = await kkpDistribService.upsertLivraison({
        annee: item.annee,
        mois: item.mois,
        [field]: next,
      });
      setItems((prev) => prev.map((row) => (
        row.annee === saved.annee && row.mois === saved.mois ? saved : row
      )));
    } catch (err) {
      notify.error(err.message);
    } finally {
      setSavingKey(null);
    }
  };

  return (
    <MasterLayout>
      <Breadcrumb
        title="Dates de livraison"
        subtitle="Calendrier MAG / SET des 12 prochains mois, visible par tous les utilisateurs"
      />

      {loading ? (
        <KkpPlanningEmptyState loading />
      ) : (
        <div className="card">
          <div className="table-responsive">
            <table className="table table-sm align-middle mb-0">
              <thead>
                <tr>
                  <th>Mois</th>
                  <th>Livraison MAG</th>
                  <th>Livraison SET</th>
                  <th>Synthèse</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr key={`${item.annee}-${item.mois}`} className={index === 0 ? 'table-light' : ''}>
                    <td>
                      <div className="fw-semibold">{item.label}</div>
                      {index === 0 ? <div className="text-secondary-light text-sm">Mois en cours</div> : null}
                    </td>
                    <td>
                      <AppInput
                        type="date"
                        size="sm"
                        value={item.date_mag || ''}
                        disabled={savingKey === `${item.annee}-${item.mois}-date_mag`}
                        onChange={(e) => {
                          const value = e.target.value;
                          setItems((prev) => prev.map((row) => (
                            row.annee === item.annee && row.mois === item.mois
                              ? { ...row, date_mag: value || null }
                              : row
                          )));
                        }}
                        onBlur={(e) => save(item, 'date_mag', e.target.value)}
                      />
                    </td>
                    <td>
                      <AppInput
                        type="date"
                        size="sm"
                        value={item.date_set || ''}
                        disabled={savingKey === `${item.annee}-${item.mois}-date_set`}
                        onChange={(e) => {
                          const value = e.target.value;
                          setItems((prev) => prev.map((row) => (
                            row.annee === item.annee && row.mois === item.mois
                              ? { ...row, date_set: value || null }
                              : row
                          )));
                        }}
                        onBlur={(e) => save(item, 'date_set', e.target.value)}
                      />
                    </td>
                    <td className="text-secondary-light text-sm">
                      MAG {formatFr(item.date_mag)} · SET {formatFr(item.date_set)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </MasterLayout>
  );
};

export default KkpDistribLivraisonsPage;
